module.exports = __webpack_public_path__ + "static/media/hammermill.62c3ab34.png";